// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1bgwK","icon":"style_icon__1As0j","title":"style_title__2yY0A"};